"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usdc = exports.bitcoin = exports.gWei = exports.ether = void 0;
var ethers_1 = require("ethers");
var ethers_2 = require("ethers");
var ether = function (amount) {
    var weiString = ethers_1.ethers.utils.parseEther(amount.toString());
    return ethers_2.BigNumber.from(weiString);
};
exports.ether = ether;
var gWei = function (amount) {
    var weiString = ethers_2.BigNumber.from("1000000000").mul(amount);
    return ethers_2.BigNumber.from(weiString);
};
exports.gWei = gWei;
var bitcoin = function (amount) {
    var weiString = 100000000 * amount; // Handles decimal Bitcoins better
    return ethers_2.BigNumber.from(weiString);
};
exports.bitcoin = bitcoin;
var usdc = function (amount) {
    var weiString = 1000000 * amount;
    return ethers_2.BigNumber.from(weiString);
};
exports.usdc = usdc;
//# sourceMappingURL=unitsUtils.js.map